import React from 'react';
import { Box, Skeleton } from '@mui/material';
import MemoryQACardSkeleton from './MemoryQACardSkeleton';

const CardContentSkeleton = () => {
  return (
    <Box display='flex' flexDirection='column' gap={1}>
      <Box
        marginTop={1}
        marginBottom={2}
        display='flex'
        gap={1}
        flexDirection='column'
      >
        <Skeleton
          variant='rectangular'
          width={50}
          height={24}
          sx={{ borderRadius: '10px' }}
        />

        <Skeleton variant='text' width='60%' height={24} />
      </Box>

      <Box display='flex' gap={0.5} flexDirection='row'>
        <Skeleton variant='text' width='20%' height={74} />
        <Skeleton variant='text' width='20%' height={74} />
        <Skeleton variant='text' width='20%' height={74} />
      </Box>

      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        border={(theme) => `1px solid ${theme.palette.borderColor}`}
        borderRadius='10px'
      >
        <MemoryQACardSkeleton />
      </Box>

      {/* Skeleton for buttons */}
      <Box display='flex' justifyContent='center'>
        <Skeleton variant='rectangular' width={120} height={55} />
      </Box>
    </Box>
  );
};

export default CardContentSkeleton;
